import { Texture } from 'pixi.js';
import { Screen, ScreenPin, InteractionEvents } from "@cc/pixi-app";
import { ButtonBase } from '../common/ButtonBase';
import FPSMeter from '../common/FPSMeter';
import { dataImporter } from './../DataImporter';


/**
 */
export class ScreenBase extends Screen {

    createMuteButton(pos) {
        this.muteButton = new ButtonBase(new Texture.from('sound_on_btn'));
        this.muteButton.interactive = true;
        this.muteButton.interactiveChildren = false;
        this.muteButton.screenPadding = 24;
        this.muteButton.anchor.set(0.5);
        this.muteButton.on(InteractionEvents.PointerTap, () => {
            this.app.sound.play("02-ui-click");
            this.app.sound.muted = !this.app.sound.muted;
            this.setMuteButtonIcon();
        });
        this.muteButton.screenPin = ScreenPin[pos];
        return this.muteButton;
    }

    setMuteButtonIcon(){
        this.mutedTexture = new Texture.from('sound_off_btn');
        this.unmutedTexture = new Texture.from('sound_on_btn');
        if (this.app.sound.muted){
            this.muteButton.texture = this.mutedTexture;
        }
        else{
            this.muteButton.texture = this.unmutedTexture;
        }
    }

    createHelpButton(pos, func) {
        this.helpButton = new ButtonBase(new Texture.from('help_btn'));
        this.helpButton.interactive = true;
        this.helpButton.anchor.set(0.5);
        this.helpButton.x = (this.app.resizer.width * 0.5) - 210;
        this.helpButton.y = (-this.app.resizer.height * 0.5) + 88;

        this.helpButton.on(InteractionEvents.PointerTap, () => {
            this.app.sound.play("02-ui-click");
            if (func) func();
        });
        return this.helpButton;
    }

    createBackButton(pos, previousScreen, texture, func, tags) {
        console.log(texture);
        if (texture) {
            this.backButton = new ButtonBase(new Texture.from(texture));
        } else {
            this.backButton = new ButtonBase(new Texture.from('home_btn'));
        }
        
        this.backButton.interactive = true;
        this.backButton.screenPadding = 24;
        this.backButton.anchor.set(0.5);
        this.backButton.screenPin = ScreenPin[pos];
        this.backButton.on(InteractionEvents.PointerTap, () => {
            this.app.sound.play("02-ui-click");
            this.app.showScreen(previousScreen || "splash", tags);
            if (func) func();
        });
        return this.backButton;
    }

    createAvatarEditorButton(pos, func) {
        this.avatarEditorButton = new ButtonBase(new Texture.from('edit_avatar_btn'));
        this.avatarEditorButton.interactive = true;
        this.avatarEditorButton.anchor.set(0.5);
        this.avatarEditorButton.x = (this.app.resizer.width * 0.5) - 160;
        this.avatarEditorButton.y = (-this.app.resizer.height * 0.5) + 32;
        this.avatarEditorButton.on(InteractionEvents.PointerTap, () => {
            this.app.sound.play("02-ui-click");
            this.app.showScreen("avatarCreator");
            if (func) func();
        });
        return this.avatarEditorButton;
    }

    static addFpsCounter() {
        let config = dataImporter.data.config;
        nick_sdk_client.GameEventListener.onDebugModeToggle = (bool)=> {
            config.enableFPSCounter = bool;
            if (config.enableFPSCounter){
                if (ScreenBase.fpsCounter){
                    ScreenBase.fpsCounter.show();
                }
                else{
                    ScreenBase.fpsCounter = new window.FPSMeter(document.body, { graph: 1, history: 20, heat: 1, theme: "dark", left: "calc(50vw - 42.5px)" });
                }
            }
            else if (ScreenBase.fpsCounter){
                ScreenBase.fpsCounter.hide();
            }
        };

        if (config.enableFPSCounter){
            ScreenBase.fpsCounter = new window.FPSMeter(document.body, { graph: 1, history: 20, heat: 1, theme: "dark", left: "calc(50vw - 42.5px)" });
        }
    }

    update(dt) {
        app.performanceManager.update(this.app.ticker.FPS);
        if (ScreenBase.fpsCounter) {
            ScreenBase.fpsCounter.tick();
        }

        if (this.helpButton && this.helpButton.transform){
            this.helpButton.x = (this.app.resizer.width * 0.5) - 210;
            this.helpButton.y = (-this.app.resizer.height * 0.5) + 88;
        }

        if (this.backButton && this.backButton.transform){
            this.backButton.x = (-this.app.resizer.width * 0.5) + 210;
            this.backButton.y = (-this.app.resizer.height * 0.5) + 88;
        }

        if (this.avatarEditorButton && this.avatarEditorButton.transform){
            this.avatarEditorButton.x = (-this.app.resizer.width * 0.5) + 330;
            this.avatarEditorButton.y = (-this.app.resizer.height * 0.5) + 88;
        }
    }
}
